import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { CurrentPlan } from "@circle-react/types";
import { useQuery } from "react-query";

import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";

const PLAN_CACHE_TIME = 1000 * 60 * 60;
const PLAN_STALE_TIME = 1000 * 60 * 10;

interface UseCurrentPlanApiOptions {
  refetchInterval?: number | false;
}

export const useCurrentPlanApi = (
  forceFromSubscription = false,
  { refetchInterval }: UseCurrentPlanApiOptions = {},
) => {
  const { currentCommunityMember } = usePunditUserContext();
  const isAdmin = Boolean(currentCommunityMember?.is_admin);

  const {
    data: currentPlan,
    isInitialLoading: isCurrentPlanLoading,
    error: errorFetchingCurrentPlan,
    refetch: refetchCurrentPlan,
    isRefetching: isRefetchingCurrentPlan,
  } = useQuery<CurrentPlan>({
    queryKey: ["community-current-plan"],
    queryFn: () =>
      reactQueryGet(
        internalApi.communities.plans.show({
          forceFromSubscription,
        }),
      ),
    retry: 2,
    enabled: isAdmin,
    gcTime: PLAN_CACHE_TIME,
    staleTime: PLAN_STALE_TIME,
    refetchInterval,
  });

  return {
    currentPlan,
    isCurrentPlanLoading,
    errorFetchingCurrentPlan,
    refetchCurrentPlan,
    isRefetchingCurrentPlan,
  };
};
